// extracted by mini-css-extract-plugin
export default {"subtitleSecondary":"WnIGy5lbXb7OqWagutIw"};